module.exports = __webpack_public_path__ + "img/nearcode_6.861d3047.svg";